export const WaTableActionBtn = ({
    icon: Icon,
    label,
    color,
    onClick,
    disabled,
}) => {
    const colors = {
        cyan: "bg-cyan-500/8 text-cyan-400 border-cyan-500/15 hover:bg-cyan-500/15 hover:border-cyan-500/25",
        amber: "bg-amber-500/8 text-amber-400 border-amber-500/15 hover:bg-amber-500/15 hover:border-amber-500/25",
        red: "bg-red-500/8 text-red-400 border-red-500/15 hover:bg-red-500/15 hover:border-red-500/25",
        blue: "bg-blue-500/8 text-blue-400 border-blue-500/15 hover:bg-blue-500/15 hover:border-blue-500/25",
        slate: "bg-slate-700/30 text-slate-400 border-slate-600/30 hover:bg-red-500/10 hover:text-red-400 hover:border-red-500/20",
    };
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`w-full flex items-center justify-center gap-1 px-1 py-[6px] rounded-lg text-[10px] font-bold transition-all border whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed ${colors[color]}`}
        >
            <Icon size={10} className="shrink-0" />
            <span>{label}</span>
        </button>
    );
};
